import Vue from 'vue';
import AlertDialog from './dialog.vue';

const AlertDialogCreator = Vue.extend(AlertDialog);
const div = document.createElement('div');

let instance = null;

export function createDialog(options) {
  instance = new AlertDialogCreator({
    el: div,
    methods: {
      deleteFn: options.deleteFn
    }
  });

  document.querySelector('#app')?.appendChild(instance.$el);
}

export function close() {
  instance.$destroy();
  document.querySelector('#app')?.removeChild(instance.$el);
}

export default createDialog;
